/* eslint-disable no-unused-vars */
import ApiClient from '../ApiClient';
import { NiceResponse } from '../dto/NiceResponse';
import { UserAuthRequest } from './dto/UserAuthRequest';
import { UserAuthResponse } from './dto/UserAuthResponse.dto';
import { UserForgotRequest } from './dto/UserForgotRequest.dto';
import { UserMeResponse } from './dto/UserMeResponse.dto';
import UserRegistrRequest from './dto/UserRegistrRequest.dto';
import { UserRegistrResponse } from './dto/UserRegistrResponse.dto';

export class RoleAssignError extends Error {
  constructor(public userId: string, public cause: unknown) {
    super('Пользователь создан, но роль не назначена');
    this.name = 'RoleAssignError';
    // target es5: без этого instanceof RoleAssignError не сработает корректно
    Object.setPrototypeOf(this, RoleAssignError.prototype);
  }
}

export class UserApi {
  constructor(private api: ApiClient) {}

  path = '/auth';

  async login(req: UserAuthRequest) {
    const resp = await this.api.client.post<NiceResponse<UserAuthResponse>>(
      this.path + '/login',
      { ...req },
    );
    return resp.data;
  }

  async forgotPassword(req: UserForgotRequest) {
    const resp = await this.api.client.put<NiceResponse<null>>(
      this.path + '/forgot-password',
      { ...req },
    );
    return resp.data;
  }

  async registration(req: UserRegistrRequest) {
    const resp = await this.api.client.post<NiceResponse<UserRegistrResponse>>(
      this.path + '/register',
      { ...req },
    );
    return resp.data;
  }

  async update(req: UserRegistrRequest, id: string) {
    const resp = await this.api.client.put<NiceResponse<null>>(
      'user/update-admin',
      { id, ...req },
    );
    return resp.data;
  }

  // Бэк игнорирует поле role при регистрации (всегда создаёт роль user),
  // поэтому нужная роль назначается вторым запросом update-admin.
  async registerWithRole(req: UserRegistrRequest) {
    const created = await this.registration(req);

    if (req.role !== 'user') {
      const id = created.body?.user?.id;

      if (!id) {
        throw new Error('Регистрация не вернула id пользователя');
      }

      try {
        await this.update(
          { name: req.name, email: req.email, password: null, role: req.role },
          id,
        );
      } catch (e) {
        throw new RoleAssignError(id, e);
      }
    }

    return created;
  }

  async me() {
    const resp = await this.api.client.get<NiceResponse<UserMeResponse>>(
      '/user/info',
    );
    return resp.data;
  }

  async getUsers(skip: number, take: number) {
    const resp = await this.api.client.get<NiceResponse<UserMeResponse[]>>(
      `/user/users?skip=${skip}&take=${take}`,
    );
    return resp.data;
  }

  async deleteUser(id: string) {
    const resp = await this.api.client.delete<NiceResponse<null>>(
      `/user/delete/${id}`,
    );
    return resp.data;
  }
}
